module.exports = __webpack_public_path__ + "static/media/DeleteImage.dcbe4713.svg";